import React from 'react';
import styled from '@emotion/styled';
import Button from '@atlaskit/button';
import { InfoPanel } from '@css-xp/base';
import { useOpenClose } from '@css-xp/ppc-custom-hooks';
import { B50, B500 } from '@atlaskit/theme/colors';
import { LinkedSubscriptionsToBillingProfileModal } from './linked-subcriptions-to-billing-profile-modal';

interface Props {
  transactionAccountId: string | null | undefined;
  invoiceGroupId: string | null | undefined;
  quoteprimaryContactName: string | null | undefined;
  quoteprimaryContactEmail: string | null | undefined;
}

const ViewLinkedSubscriptionsButton = styled.div`
  background-color: ${B50};
  > button {
    background: none;
    padding-top: 2px;
    padding: 0px !important;
    color: ${B500} !important;
    &:hover {
      color: ${B500} !important;
      background-color: ${B50};
    }
  }
`;

const InfoMessageContent = styled.div`
  padding-top: 6px;
  padding-bottom: 2px;
`;

const PrimaryContactChangePanel = styled.div`
  margin: 10px;
`;

export const PrimaryContactChangeInfoPanel = ({
  transactionAccountId,
  invoiceGroupId,
  quoteprimaryContactEmail,
  quoteprimaryContactName,
}: Props) => {
  const { isOpen: isModalOpen, open: openModal, close: closeModal } = useOpenClose();
  const [showModal, setShowModal] = React.useState(false);
  const handleViewSubscriptionsButtonClick = () => {
    openModal();
    setShowModal(true);
  };

  const infoMessage = (
    <div>
      <h3>Primary contact changed</h3>
      <InfoMessageContent>
        {quoteprimaryContactName ? quoteprimaryContactName : ''}{' '}
        {quoteprimaryContactEmail ? `(${quoteprimaryContactEmail})` : ''} will become the primary customer contact for
        all the subscriptions in this billing profile when the order is confirmed.
      </InfoMessageContent>
      <ViewLinkedSubscriptionsButton>
        <Button onClick={() => handleViewSubscriptionsButtonClick()}>View linked subcriptions</Button>
      </ViewLinkedSubscriptionsButton>
    </div>
  );

  return (
    <PrimaryContactChangePanel>
      <InfoPanel type="information" message={infoMessage} />
      {showModal && (
        <LinkedSubscriptionsToBillingProfileModal
          invoiceGroupId={invoiceGroupId}
          isOpen={isModalOpen}
          onClose={() => {
            closeModal();
            setShowModal(false);
          }}
          transactionAccountId={transactionAccountId}
        />
      )}
    </PrimaryContactChangePanel>
  );
};
